import { createInertiaApp } from '@inertiajs/react'
import { resolvePage } from './resolvePage'
import { watchRestoredUrl } from '../pages/explore/_expandUrl'
import { startPerfProbe } from '../pages/_perfProbe'

// BEFORE createInertiaApp, AND THAT IS THE POINT. The home map reads which URL
// the back button restored, and Inertia rewrites the address bar from its own
// listener — registered inside createInertiaApp, so anything registered after
// this line reads a repaired address bar rather than the restored one. One
// listener, no behaviour: it records the URL and returns. See _expandUrl.js.
watchRestoredUrl()

// `?perf=1` in a DEV or VITE_E2E_HANDLES bundle turns on the frame-time probe
// (see _perfProbe.js): rAF cadence, map repaint cadence, canvas pixel count and
// the ratio the canvas actually rendered at. It is how the phone-heat wins are
// measured — a no-op with no query param, and unreachable in a production
// bundle. Registered here rather than in a page component so a station page and
// the explore map get the same probe.
startPerfProbe()

createInertiaApp({
  resolve: resolvePage,

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: 'brackets' }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById('app')) {
    throw error
  } else {
    console.error(
      'Missing root element.\n\n' +
        'If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n' +
        'Consider moving <%= vite_javascript_tag "inertia.jsx" %> to the Inertia-specific layout instead.',
    )
  }
})
